import React, { createContext, useContext, useMemo, useState } from 'react';
import { copy, Copy, Language } from '../data/translations';
type LanguageContextValue = {
  language: Language;
  setLanguage: (language: Language) => void;
  t: Copy;
};
const LanguageContext = createContext<LanguageContextValue | null>(null);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('id');
  const value = useMemo(() => ({
    language,
    setLanguage,
    t: copy[language]
  }), [language]);
  return <LanguageContext.Provider value={value} data-id="element-141" data-mp="z5myiogx4xgs">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage(): LanguageContextValue {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return ctx;
}